import { domel } from '@easydata/ui';
import { i18n } from '@easyquery/core';
var ExportDialog = /** @class */ (function () {
    function ExportDialog(context) {
        this.context = context;
        this.promise = null;
    }
    ExportDialog.prototype.show = function (defFormat) {
        var _this = this;
        if (defFormat === void 0) { defFormat = null; }
        if (!this.promise) {
            var formats = this.context.getExportFormats();
            if (formats.length == 0)
                throw Error("No exporter has been registered.");
            defFormat = defFormat || formats[0];
            this.promise = new Promise(function (resolve, reject) {
                var ds = _this.context.getServices().getDialogService();
                var body = domel('div')
                    .addClass('kdlg-form-section')
                    .addChild('div', function (b) { return b
                    .addClass('kfrm-form')
                    .addChild('div', function (b) { return b
                    .addClass('kfrm-fields col-a-1 label-align-right')
                    .addChild('label', function (b) { return b
                    .addClass('kdlg-form-label', 'kflex-20')
                    .attr('for', 'export_format')
                    .addText(i18n.getText('ExportDlgFmtLabel')); })
                    .addChild('div', function (b) { return b
                    .addClass('kfrm-select')
                    .addChild('select', function (b) {
                    b
                        .attr('name', 'export_format')
                        .id('exportFormat');
                    for (var _i = 0, _a = _this.context.getExportFormats(); _i < _a.length; _i++) {
                        var format = _a[_i];
                        b.addOption({
                            value: format,
                            title: i18n.getText(format) || format,
                            selected: defFormat == format
                        });
                    }
                }); }); }); })
                    .toDOM();
                ds.open({
                    title: i18n.getText('ExportDlgTitle'),
                    body: body,
                    onSubmit: function () {
                        var format = body.querySelector('#exportFormat').value;
                        _this.context.exportResult({
                            format: format,
                            success: resolve,
                            error: reject
                        });
                        return true;
                    }
                });
            });
        }
        return this.promise.finally(function () { return _this.promise = null; });
    };
    return ExportDialog;
}());
export { ExportDialog };
//# sourceMappingURL=export_dialog.js.map